import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, MessageCircle } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { trackContact } from '../utils/pixel';
export function HeroSection() {
  const {
    t
  } = useLanguage();
  const scrollToForm = () => {
    document.getElementById('lead-form')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const whatsappLink = `https://wa.me/19548223252?text=${encodeURIComponent(t('wa.hero'))}`;
  return <section className="relative w-full h-[100svh] min-h-[560px] overflow-hidden" data-id="element-67">
      <div className="absolute inset-0 w-full h-full bg-cover bg-center bg-no-repeat scale-105" style={{
      backgroundImage: "url('https://cdn.magicpatterns.com/uploads/3ZKjYiqPS8nANgAw6E59b2/pasted-image.jpg')",
      backgroundPosition: 'center center'
    }} data-id="element-68" />

      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/50 to-black/20 md:bg-gradient-to-r md:from-black/80 md:via-black/40 md:to-transparent" data-id="element-69" />

      <div className="relative z-10 container mx-auto px-5 md:px-6 h-full flex flex-col justify-end pb-28 md:justify-center md:pb-0" data-id="element-70">
        <div className="max-w-2xl" data-id="element-71">
          <motion.p className="text-xs md:text-sm font-bold uppercase tracking-[0.25em] mb-3 md:mb-4" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-72">
            <span className="text-white font-black tracking-[0.15em]" data-id="element-73">
              MITCHELL
            </span>
            <span className="text-[#d4a853] ml-1.5 font-light tracking-[0.2em]" data-id="element-74">
              THE KIA BOSS
            </span>
            <span className="text-white/40 mx-2" data-id="element-75">—</span>
            <span className="text-white/50 font-normal" data-id="element-76">Miami, FL</span>
          </motion.p>

          <motion.h1 className="text-[2.5rem] leading-[1.05] md:text-6xl lg:text-7xl font-black text-white uppercase tracking-tight mb-4 md:mb-5" initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: 0.1,
          ease: [0.22, 1, 0.36, 1]
        }} data-id="element-77">
            {t('hero.headline1')}
            <br data-id="element-78" />
            <span className="text-[#d4a853]" data-id="element-79">{t('hero.headline2')}</span>
          </motion.h1>

          <motion.p className="text-base md:text-lg text-white/80 mb-7 md:mb-8 max-w-md font-light" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: 0.25
        }} data-id="element-80">
            {t('hero.sub')}
          </motion.p>

          <motion.div className="flex flex-col sm:flex-row gap-3" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: 0.4
        }} data-id="element-81">
            <button onClick={scrollToForm} data-track-cta="hero-cta" className="btn-primary py-3.5 px-7 md:py-4 md:px-8 rounded-md text-sm md:text-base flex items-center justify-center gap-2" data-id="element-82">
              {t('hero.cta1')}
              <ArrowRight className="w-4 h-4" data-id="element-83" />
            </button>
          </motion.div>

          {/* Objection-busting micro-bullets */}
          <motion.div className="flex flex-wrap gap-x-4 gap-y-1.5 mt-4" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: 0.6
        }} data-id="element-84">
            {(['hero.bullet1', 'hero.bullet2', 'hero.bullet3'] as const).map((key, i) => <span key={i} className="flex items-center gap-1.5 text-white/70 text-xs md:text-sm" data-id="element-85">
                  <span className="text-[#C41230] font-bold" data-id="element-86">✓</span>
                  {t(key)}
                </span>)}
          </motion.div>
        </div>
      </div>
    </section>;
}